import React from "react";
import { principles } from "../../data/principles";
const cellBorders = ["", "sm:border-l sm:pl-8", "lg:border-l lg:pl-8", "sm:border-l sm:pl-8"];
export function ConstantStandard() {
  return <section aria-labelledby="constant-standard" className="bg-navy text-ivory" data-id="element-144" data-mp="7wjobvl1uohc">
      <div className="shell py-24 md:py-32" data-id="element-145" data-mp="byerl5mjjbxr">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8" data-id="element-146" data-mp="bxdc8oyhs3a8">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-147" data-mp="3bebq21ozmmsq">
            <p className="eyebrow text-ivory/75" data-id="element-148" data-mp="3bbp8d98duqws">The Constant Standard</p>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-149" data-mp="3gd4r2un38lc0">
            <h2 id="constant-standard" className="max-w-4xl font-display text-[clamp(2.5rem,5vw,4.5rem)] leading-[1.02] tracking-[-0.01em]" data-id="element-150" data-mp="3ke883kgvgnet">
              Payroll operations should get <em className="text-stone" data-id="element-151" data-mp="2sm96oikyoses">stronger</em> with every cycle.
            </h2>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-ivory/75" data-id="element-152" data-mp="2wo461hjc0vpx">
              Constant does not exist to repeatedly clean up the same problems. We identify what is breaking, determine
              why it is happening, and build the processes, controls, systems, and accountability that make the
              operation stronger over time.
            </p>
          </div>
        </div>

        <ol className="mt-16 grid grid-cols-1 border-t border-ivory/30 sm:grid-cols-2 lg:grid-cols-4 md:mt-20" data-id="element-153" data-mp="3d697bhisi6ld">
          {principles.map((p, i) => <li key={p.number} className={`flex flex-col border-b border-ivory/20 py-10 sm:pr-8 lg:border-b-0 ${cellBorders[i]}`} data-id="element-154" data-mp="3841pibba3wb4" data-mpi={i}>
              <span className="font-display text-lg tabular-nums text-ivory/55" data-id="element-155" data-mp="2z56i4vwi0g68">{p.number}</span>
              <h3 className="mt-5 font-display text-[1.75rem] leading-[1.12]" data-id="element-156" data-mp="2u751ehmjosxx">{p.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-ivory/70" data-id="element-157" data-mp="xe35y26ymtjk">{p.line}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}